// extracted by mini-css-extract-plugin
export default {"privacyCtn":"Terms_privacyCtn__fdQkJ","privacyMainTitle":"Terms_privacyMainTitle__JC2Xe","privacySecondTitle":"Terms_privacySecondTitle__1jy96","divCard":"Terms_divCard__8W2iz"};